import { Capacitor } from "@capacitor/core";

export type AppPlatform = "web" | "ios" | "android";

export function getPlatform(): AppPlatform {
  const platform = Capacitor.getPlatform();
  if (platform === "ios") return "ios";
  if (platform === "android") return "android";
  return "web";
}

export function isNativePlatform(): boolean {
  return Capacitor.isNativePlatform();
}

export function isIOS(): boolean {
  return Capacitor.getPlatform() === "ios";
}

export function isAndroid(): boolean {
  return Capacitor.getPlatform() === "android";
}

export function isWebPlatform(): boolean {
  return !Capacitor.isNativePlatform();
}
